<template>
  <v-container fluid>
    <v-tabs
      v-model="tab"
      color="transparent"
      show-arrows
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab
        v-for="tabName in tabHeaders"
        :key="tabName"
        ripple
      >
       {{tabName}}
      </v-tab>
      <v-tab-item
        v-for="(n, index) in 2"
        :key="index"
      >
      <div v-if="tab === 0 && index === 0">
        <PaginationController
          v-model="returnPackages"
          getDataActionName="getReturnPackagesWithPagination"
          haveSearchBox
          keepKeywordCase
          haveStartDate
          :select="selectedValue"
          :searchBoxLabel=" isAdmin ? `${$t('trackingNumber')} / ${$t('clientName')}`  : $t('trackingNumber')"
          :historyLimit="historyLimit"
          :isRefreshSelect='false'
          :isStartWithoutData="true"
        >
          <template v-slot:beforeSearchBox>
            <v-flex md4>
              <v-autocomplete
                v-model="selectedValue"
                :items="returnPkgStatus"
                :label="$t('selectStatus')"
                item-text="displayName"
                item-value="key"
              ></v-autocomplete>
            </v-flex>
          </template>
          <template v-slot:beforeMenu v-if="isAdmin">
            <v-flex md1 class="headline">
              <v-btn
                color="primary"
                @click="addNewPackage"
                :disabled="!eeveeOrgId"
              >
                <v-icon dark>add</v-icon> {{ $t('returnPackages') }}</v-btn>
            </v-flex>
            <v-flex style="position:relative" v-if="!eeveeOrgId">
              <span class="returnPackageFloatText">{{$t('apiIdIsRequired')}}</span>
            </v-flex>
          </template>
          <template v-slot:dataTable>
            <v-data-table :headers="headers" :items="returnPackages" hide-actions>
              <template v-slot:items="props">
                <td class="text-xs-center">
                 {{ props.index + 1}}
                </td>
                <td class="text-xs-left">
                 {{props.item.trackingNumber}}
                </td>
                <td class="text-xs-left">
                 {{props.item.clientName || `[${props.item.orgId}]`}}
                </td>
                <td class="text-xs-left">{{ toDateYYYYMMDD(props.item.returnCreateTime) }}</td>
                <td class="text-xs-left">
                  <v-layout column>
                    <v-flex>
                      {{`${$t('status')}: ${$t(props.item.status === 'error' ? 'returnError' : props.item.status)}`}}
                    </v-flex>
                    <v-flex
                      class="text-truncate"
                      v-if="(props.item.comments || []).length" 
                      mb-2 xs12>
                      <b class="mr-2">
                        {{ props.item.comments[props.item.comments.length-1].name }}
                        [{{ toDateMMDDHHmm(props.item.comments[props.item.comments.length-1].createTime) }}]: 
                      </b>
                      {{ lastCommentPreview(props.item) }}
                  </v-flex>
                  </v-layout>
                </td>
                <td class="text-xs-left" v-if="isAdmin">
                  <span style="white-space: normal">
                    {{props.item.note || ''}}
                  </span>
                </td>
                <td class="text-xs-left">
                  <v-layout align-center justify-center>
                    <v-flex md3 v-if="isAdmin">
                      <v-btn icon flat color="primary" @click="downLoadLabel(props.item)" :disabled="!(props.item.readyLabels && props.item.readyLabels.length)">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" v-on="on" small style="font-size: 25px">cloud_download</v-icon>
                          </template>
                          {{ $t('download') }}
                        </v-tooltip>
                      </v-btn>
                    </v-flex>
                    <v-flex md3 v-if="isAdmin">
                      <v-menu offset-y v-if="isAdmin">
                        <template v-slot:activator="{ on }">
                          <v-tooltip top>
                            <template v-slot:activator="tooltip">
                              <div v-on="tooltip.on">
                                <v-btn icon @click.stop="on.click" color="primary" flat><v-icon>build</v-icon></v-btn>
                              </div>
                            </template>
                            {{ $t('more') }}
                          </v-tooltip>
                        </template>
                          <v-list>
                            <v-list-tile @click="editSinglePackage(props.item)">
                              <v-list-tile-title>{{ $t('edit') }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="deleteSinglePackage(props.item)">
                              <v-list-tile-title>{{ $t('delete') }}</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                    </v-flex>
                    <v-flex v-if="!isAdmin && isShowTenantBtns(props.item)" md3>
                      <v-btn color="primary" icon flat @click="showResendPopup(props.item)">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" v-on="on" small>schedule_send</v-icon>
                          </template>
                          {{$t('requestResend')}}
                        </v-tooltip>
                      </v-btn>
                    </v-flex>
                    <v-flex v-if="!isAdmin && isShowTenantBtns(props.item)" md3>
                      <v-btn color="primary" icon flat @click="requestForDisposal(props.item)">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" v-on="on" small>recycling</v-icon>
                          </template>
                          {{$t('requestDisposal')}}
                        </v-tooltip>
                      </v-btn>
                    </v-flex>
                    <v-flex md3 class="chatRoom">
                      <v-btn color="primary" icon flat @click="showChatRoom(props.item)">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" v-on="on" small>comment</v-icon>
                          </template>
                          {{$t('open')}}
                        </v-tooltip>
                        <v-badge color="red" v-if="checkNewMessage(props.item)">
                          <template v-slot:badge>
                            <span style="font-size: 10px">{{ $t('new') }}</span>
                          </template>
                        </v-badge>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </td>
              </template>
            </v-data-table>
          </template>
        </PaginationController>
          <FormSubmitPopup
            v-model="isShowNewPackagePopup"
            v-if="isShowNewPackagePopup"
            :title="$t('addPackage')"
            :label="$t('addPackage')"
            :rightMethod="saveNewPackages"
            @popupClose="() => closeAddPackagePopup()"
            :rightButtonDisabled="!newItemList.length"
            large
            >
            <template v-slot:input>
              <v-layout justify-start align-center>
                <v-flex md2>
                  <v-btn color="primary" @click="addNewItem">
                    <v-icon dark left class="mx-2">add</v-icon> {{$t('package')}}
                  </v-btn>
                </v-flex>
                <v-flex md2>
                  <v-btn color="primary" title="importFile" :loading="isUploadingFile">
                    <v-icon dark left>cloud_upload</v-icon>
                    {{ $t('upload') }}
                    <input type="file" ref="fileUploader" class="hideInput" @change="analysizeFileData" accept=".csv,.xls,.xlsx" />
                  </v-btn>
                </v-flex>
                <v-flex md2>
                  <v-btn color="primary" @click="downloadReturnTemplate">
                    <v-icon dark left class="mx-2">cloud_download</v-icon> {{$t('template')}}
                  </v-btn>
                </v-flex>
                <v-flex v-if="isAfterCheck && !isAvailableToSubmit && newItemList.length">
                  <span style="color:red">{{$t('returnPackageTipForAdd')}}</span>
                </v-flex>
              </v-layout>
              <v-form ref="addPkgPopupForm">
                <v-layout v-for="(item, index) in newItemList" :key="index" justify-space-between align-baseline>
                  <v-flex>
                    <v-layout justify-space-around align-center :style="{ backgroundColor: (item.isExists && !returnPackageCache.includes(item.trackingNumber) && !localReturnPkgTrackingCacheRepeated.includes(item.trackingNumber)) ? '' : (item.isExists === false || localReturnPkgTrackingCacheRepeated.includes(item.trackingNumber) || returnPackageCache.includes(item.trackingNumber)) ? 'yellow' : '' }">
                      <v-flex md3>
                        <v-text-field
                          :label="$t('trackingNumber')"
                          v-model.trim="item.trackingNumber"
                          :rules="[
                            fieldIsRequired($t('trackingNumber'))
                          ]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md2 ml-4>
                        <DatePicker v-model="item.returnCreateTime"></DatePicker>
                      </v-flex>
                      <v-flex md3 ml-4>
                        <v-select
                          :items="statusList"
                          :label="$t('status')"
                          item-text="displayName"
                          item-value="key"
                          v-model="item.status"
                          clearable
                        ></v-select>
                      </v-flex>
                      <v-flex md2 ml-4 v-if="!returnPackageCache.includes(item.trackingNumber) && !localReturnPkgTrackingCacheRepeated.includes(item.trackingNumber) && !item.errMsg">
                        {{ item.clientName || item.orgId || ''}}
                      </v-flex>
                      <v-flex md2 ml-4 v-else>
                        {{ returnPackageCache.includes(item.trackingNumber) ? 
                          $t('historyDuplicated') : localReturnPkgTrackingCacheRepeated.includes(item.trackingNumber) 
                            ? $t('localDuplicated') : item.errMsg ? $t('notFound') : ''}}
                      </v-flex>
                      <v-flex md1 ml-2>
                        <v-btn icon flat color="primary" @click="removeItemFromList(index)">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-form>
              
            </template>
          </FormSubmitPopup>
         <FormSubmitPopup
            v-model="isShowEditPackagePopup"
            v-if="isShowEditPackagePopup"
            :title="$t('editPackage')"
            :label="$t('editPackage')"
            :leftMethod="closeEditPackagePopup"
            :rightMethod="updatePackage"
            @popupClose="() => closeEditPackagePopup()"
            medium
          >
            <template v-slot:input>
              <v-layout justify-space-around>
                <v-flex md5>
                  <v-text-field
                    :label="$t('trackingNumber')"
                    v-model="packageInEdit.trackingNumber"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex md5>
                  <v-autocomplete
                    v-model="packageInEdit.status"
                    :items="statusList"
                    :label="$t('selectStatus')"
                    item-text="displayName"
                    item-value="key"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout justify-center>
                <v-flex md11>
                  <v-textarea
                    :label="$t('note')"
                    outline
                    v-model="packageInEdit.note"
                    rows="4"
                    :counter="noteLengthLimit"
                    class="thinBox"></v-textarea>
                </v-flex>
              </v-layout>
            </template>
          </FormSubmitPopup>

      </div>
      <div v-if="tab === 1 && index === 1">
        <PaginationController
          v-model="archivedPackages"
          getDataActionName="getReturnPackagesWithPagination"
          :haveSearchBox="isAdmin ? true : false"
          keepKeywordCase
          :searchBoxLabel="`${$t('trackingNumber')} / ${$t('clientName')}`"
          :historyLimit="historyLimit"
          :actionPredicates='historyActionPredicates'
          :isRefreshSelect='false'
          :isStartWithoutData="true"
        >
          <template v-slot:dataTable>
            <v-data-table :headers="archivedHeaders" :items="archivedPackages" hide-actions>
              <template v-slot:items="props">
                <td class="text-xs-center">
                 {{ props.index + 1}}
                </td>
                <td class="text-xs-left">
                  {{props.item.trackingNumber}}
                </td>
                <td class="text-xs-left">
                  {{props.item.clientName}}
                </td>
                <td class="text-xs-left">{{ toDateYYYYMMDD(props.item.returnCreateTime) }}</td>
                <td class="text-xs-left">
                  <v-layout column>
                    <v-flex>
                      {{`${$t('status')}: ${$t(props.item.status)}`}}
                    </v-flex>
                    <v-flex
                      class="text-truncate"
                      v-if="(props.item.comments || []).length" 
                      mb-2 xs12>
                      <b class="mr-2">
                        {{ props.item.comments[props.item.comments.length-1].name }}
                        [{{ toDateMMDDHHmm(props.item.comments[props.item.comments.length-1].createTime) }}]: 
                      </b>
                      {{ lastCommentPreview(props.item) }}
                  </v-flex>
                  </v-layout>
                </td>
                <td class="text-xs-left" v-if="isAdmin" :style="whiteSpace='pre'">
                  {{props.item.note || ''}}
                </td>
              </template>
            </v-data-table>
          </template>
        </PaginationController>
      </div>
      </v-tab-item>
    </v-tabs>
    <ChatRoom
      v-model="isShowChatRoom"
      :title="$t('supportChatRoomTitle', { caseNumber: packageInEdit.trackingNumber, status: $t(packageInEdit.status) })"
      v-if="isShowChatRoom"
      :docPath="['returnPackages', packageInEdit.trackingNumber]"
      :comments="comments"
      :lastReadTime="getLastReadTime(packageInEdit)"
      :readOnly="packageInEdit && packageInEdit.status === 'done'"
      :nickName="isAdmin ? agent : ''"
      enableFileUpload
      @add="getNewComment"
      @getLocalUnread="updateLocalLastReadTime"
    >
      <template v-if="isAdmin" v-slot:operation>
        <v-layout row no-wrap align-baseline>
          <v-flex>
            <v-btn v-if="packageInEdit.status !== 'done'" small color="primary" @click.stop="updatePackage({}, true)">{{ $t('resolve') }}</v-btn>          
          </v-flex>
        </v-layout>
      </template>
    </ChatRoom>
    <SimpleTextPopup
      v-model="isShowResendPopup"
      v-if="isShowResendPopup"
      @popupClose="() => isShowResendPopup = false"
      :rightMethod="requestForResend"
      :rightButtonDisabled="!uploadedFile.length"
      :rightButtonText="$t('submit')"
      medium
      >
      <template v-slot:input>
        <v-container>
          <v-layout column justify-center align-center>
            <v-flex>{{$t('createTime') + ': ' + toDateYYYYMMDD(packageInEdit.returnCreateTime)}}</v-flex>
            <v-flex>{{$t('status') + ': ' + $t(packageInEdit.status)}}</v-flex>
            <v-flex>
              <UploadFileWidget
                :maxFiles="1"
                iconType="attachment"
                :type="'returnPackagesLabel' + '/' + packageInEdit.billingNumber"
                v-model="uploadedFile"
                class="returnPackageUploader"
                ></UploadFileWidget>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </SimpleTextPopup>
  </v-container>
</template>

<script>
import PaginationController from './PaginationController.vue'
import FormSubmitPopup from './FormSubmitPopup.vue'
import ChatRoom from './ChatRoom.vue'
import DatePicker from './DatePicker.vue'
import UploadFileWidget from './UploadFileWidget.vue'
import {getFieldListColumnPosition, checkRules, timeTools, cloneDeep} from '../utils/tools'
import xlsx from 'xlsx'
import SimpleTextPopup from './SimpleTextPopup.vue'
import {thirdPartModuleConfig} from '../../config/moduleConfig'
export default {
  name: 'ReturnPackages',
  data () {
    return {
      tab: null,
      valid: true,
      tabHeaders: [this.$t('active'), this.$t('history')],
      selectedValue: '',
      historyLimit: 25,
      noteLengthLimit: 1000,
      returnPackages: [],
      archivedPackages: [],
      returnPkgStatus: [
        { displayName: `-- ${this.$t('all')} --`, key: '' },
        { displayName: this.$t('returnReceived'), key: 'returnReceived' },
        { displayName: this.$t('requestResend'), key: 'requestResend' },
        { displayName: this.$t('resendInProgress'), key: 'resendInProgress' },
        { displayName: this.$t('requestDisposal'), key: 'requestDisposal' },
        { displayName: this.$t('disposalInProgress'), key: 'disposalInProgress' },
        { displayName: this.$t('returnError'), key: 'error' }
      ],
      isShowNewPackagePopup: false,
      isShowEditPackagePopup: false,
      isShowChatRoom: false,
      isUploadingFile: false,
      isAfterCheck: false,
      isShowResendPopup: false,
      rowPerPage: [15, 30, 50, {text: this.$t('all'), value: -1}],
      pagination: {
        sortBy: 'createTime'
      },
      uploadedFile: [],
      newItemList: [{
        trackingNumber: '',
        status: 'returnReceived',
        orgId: ''
      }],
      packageInEdit: {},
      historyActionPredicates: [
        {
          field: 'status',
          compare: '==',
          value: 'done'
        }
      ]
    }
  },
  mixins: [checkRules, timeTools],
  mounted () {
    this.buildRTForReturnPkgCache()
  },
  components: { PaginationController, FormSubmitPopup, ChatRoom, DatePicker, SimpleTextPopup, UploadFileWidget },
  computed: {
    headers () {
      const headers = this.isAdmin ? [
        { text: this.$t('tracking'), value: 'trackingNumber', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('clientName'), align: 'left', sortable: false, width: '15%' },
        { text: this.$t('createTime'), align: 'left', sortable: false, width: '15%' },
        { text: this.$t('detail'), align: 'left', sortable: false, width: '15%' },
        { text: this.$t('note'), align: 'left', sortable: false, width: '25%' },
        { text: this.$t('actions'), align: 'center', sortable: false, width: '8%' }
      ] : [
        { text: this.$t('tracking'), value: 'trackingNumber', align: 'left', sortable: false, width: '22%' },
        { text: this.$t('clientName'), align: 'left', sortable: false, width: '22%' },
        { text: this.$t('createTime'), align: 'left', sortable: false, width: '22%' },
        { text: this.$t('detail'), align: 'left', sortable: false, width: '28%' },
        { text: this.$t('actions'), align: 'center', sortable: false, width: '6%' }
      ]
      headers.unshift({ text: '#', value: '', align: 'center', sortable: false })
      return headers
    },
    archivedHeaders () {
      return this.headers.slice(0, -1)
    },
    statusList () {
      return this.returnPkgStatus.slice(1).concat([{displayName: this.$t('done'), key: 'done'}])
    },
    isAdmin () {
      return !!(this.$store.getters.user || {}).isAdmin
    },
    isHaveDataUnsaved () {
      return this.newItemList.length && this.newItemList.some(item => item.trackingNumber)
    },
    isAvailableToSubmit () {
      return this.newItemList.length && !this.localReturnPkgTrackingCacheRepeated.length && this.newItemList.every(item => !this.returnPackageCache.includes(item.trackingNumber) && item.isExists)
    },
    comments () {
      return (this.packageInEdit && this.packageInEdit.comments) || []
    },
    agent () {
      return (this.$store.getters.userExtra && this.$store.getters.userExtra.name) || 
        'warehouse manager'
    },
    returnPackageCache () {
      return this.$store.getters.returnPackageCache
    },
    returnPkgStatusList () {
      return this.statusList.map(item => item.key)
    },
    uid () {
      return this.$store.getters.uid
    },
    localReturnPkgTrackingCache () {
      return [...new Set(this.newItemList.filter(item => item.trackingNumber).map(item => item.trackingNumber))]
    },
    localCheckedTrackingCache () {
      return [...new Set(this.newItemList.filter(item => item.trackingNumber && item.isExists !== undefined).map(item => item.trackingNumber))]
    },
    localReturnPkgTrackingCacheRepeated () {
      const localTrackingAndRepeatTime = []
      const localTrackingMap = new Map()
      this.newItemList.filter(item => item.trackingNumber).forEach((item, index) => {
        if (localTrackingMap.has(item.trackingNumber)) {
          const position = localTrackingMap.get(item.trackingNumber)
          localTrackingAndRepeatTime[position][1] += 1 
        } else {
          localTrackingMap.set(item.trackingNumber, index)
          localTrackingAndRepeatTime.push([item.trackingNumber, 1])
        }
      })
      return localTrackingAndRepeatTime.filter(([a, b]) => b > 1).map(item => item && item[0])
    },
    eeveeOrgId () {
      return this.$store.getters.eeveeOrgId
    },
    systemApiIdList () {
      return this.$store.getters.apiIdList || []
    },
    env () {
      return process.env.NODE_ENV
    },
    curSystem () {
      const allSystemKey = Object.keys(thirdPartModuleConfig)
      return allSystemKey.includes(this.env) ? this.env : 'viteusa'
    }
  },
  created () {
    this.$store.dispatch('loadSystemInfo')
    this.$store.dispatch('getAllSystemBalances')
    this.$store.dispatch('checkToShowReturnPackageNotification')
  },
  methods: {
    addNewPackage () {
      this.isShowNewPackagePopup = true
      this.newItemList = [{
        trackingNumber: '',
        status: 'returnReceived',
        orgId: '',
        returnCreateTime: new Date()
      }]
    },
    closeAddPackagePopup () {
      if (!this.isHaveDataUnsaved || this.isAvailableToSubmit || (this.isHaveDataUnsaved && confirm('data will not be saved, sure to leave ?'))) {
        this.resetData()
      }
    },
    async updateLocalLastReadTime (isMarkAsUnread = false) {
      if (isMarkAsUnread) return
      this.returnPackages = this.returnPackages.map(pkg => {
        if (pkg.trackingNumber === this.packageInEdit.trackingNumber) {
          pkg[`lastRead_${this.uid}`] = new Date()
        }
        return pkg
      })
    },
    resetData () {
      this.isShowNewPackagePopup = false
      this.newItemList = [{
        trackingNumber: '',
        status: 'returnReceived',
        orgId: ''
      }]
      this.isAfterCheck = false
    },
    async saveNewPackages () {
      if (this.$refs.addPkgPopupForm[0].validate()) {
        await this.splitTrackingNumberPiecesAndProcess()
        if (this.isAvailableToSubmit) {
          // 将新增的项目缓存下来，数据库存储完成后，手动在前端添加
          const newItemListCache = cloneDeep(this.newItemList.filter(item => item.status !== 'done'))
          this.saveNewReturnItemsToDatabase(this.newItemList)
            .then(() => {
              // 前端手动添加新增项
              this.returnPackages.unshift(...newItemListCache)
            })
        } else {
          this.isAfterCheck = true
          return Promise.resolve('keepPopup')
        }
      } else {
        this.isAfterCheck = true
        return Promise.resolve('keepPopup')
      }
    },
    addNewItem () {
      this.newItemList.unshift({
        status: 'returnReceived',
        returnCreateTime: new Date()
      })
    },
    async getLabelsStatusInEevee (trackingNumberListPieces = [], trackingNumberDataMap = new Map()) {
      // 此处itemList为用户填写的原生数据，或者已经经过第一轮查询后组装后的数据
      // 查询前需对数据进行过滤，将（数据库 || 本地）重复的，已经查询过的数据，过滤
      // 考虑到重新组装数据需要多次遍历，可以添加map用来将对应项原来位置缓存起来
      // eevee端限制单次最多50个trackingNumber

      const eeveeDataList = await this.$store.dispatch('getLabelInfoInEevee', {trackingNumbers: trackingNumberListPieces})
      trackingNumberListPieces.forEach((trackingNumber, index) => {
        const dataInEevee = eeveeDataList.data[index]
        !trackingNumberDataMap.has(trackingNumber) && trackingNumberDataMap.set(trackingNumber, dataInEevee)
      })
    },
    async splitTrackingNumberPiecesAndProcess () {
      // 查询eevee前，需进行数据查重，包括数据库查重和本地数据查重
      // 数据库查重根据real-time的cache进行判断
      // 本地查重在遍历数据时，将第一次添加的trackingNumber缓存一份
      // 本地缓存由computed根据newItemList生成，有重复时，将重复的都标识出来，本地删除某一个后，没有重复的就恢复正常
      const maxTrackingNumberLength = 30
      // localReturnPkgTrackingCache 已将本地有状态的数据过滤掉了
      const deDupPkgTrackingNumber = this.localReturnPkgTrackingCache.filter(trackingNumber => !this.returnPackageCache.includes(trackingNumber) && !this.localCheckedTrackingCache.includes(trackingNumber))
      if (!deDupPkgTrackingNumber.length) return
      const trackingNumberIndexMap = new Map()
      const trackingNumberDataMap = new Map()
      this.newItemList.forEach((item, index) => {
        !trackingNumberIndexMap.has(item.trackingNumber) && trackingNumberIndexMap.set(item.trackingNumber, index)
      })
      for (let index = 0; index < Math.ceil(deDupPkgTrackingNumber.length / maxTrackingNumberLength); index++) {
        const trackingNumberListPieces = deDupPkgTrackingNumber.slice(index * maxTrackingNumberLength, (index + 1) * maxTrackingNumberLength)
        try {
          await this.getLabelsStatusInEevee(trackingNumberListPieces, trackingNumberDataMap)
        } catch (error) {
          console.log('error', error)
        }
      }
      const allLabelListInfoInEevee = this.newItemList.map(item => {
        if (trackingNumberDataMap.has(item.trackingNumber)) return {...item, ...trackingNumberDataMap.get(item.trackingNumber)}
        return item
      })

      this.newItemList = cloneDeep(allLabelListInfoInEevee)
    },
    async analysizeFileData (event) {
      this.isUploadingFile = true
      const files = event.target.files
      if (!files.length) return
      let reader = new FileReader()
      reader.readAsBinaryString(files[0])
      reader.onload = async e => {
        // 目前只支持单文件上传
        let fileData = e.target.result
        const workbook = xlsx.read(fileData, {type: 'binary'})
        const sheetName = workbook.SheetNames[0]
        const workingSheetName = workbook.Sheets[sheetName]
        const targetColumnsList = ['trackingNumber', 'createTime', 'status', 'isExists', 'system', 'orgId', 'clientKey', 'clientName']
        let rawData = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName])
        const columnAlphabetMap = getFieldListColumnPosition(xlsx, workbook, sheetName, targetColumnsList, 1)
        let pkgInfoList = []
        const rawDataMap = new Map()
        // 将excel里面的所有数据读出来
        for (let i = 0; i < rawData.length; i++) {
          const pkgObj = {}
          for (let index = 0; index < targetColumnsList.length; index++) {
            if (!workingSheetName[columnAlphabetMap.get('trackingNumber') + '' + (i + 2)]) continue
            const columnAlphabet = targetColumnsList[index]
            const position = workingSheetName[columnAlphabetMap.get(columnAlphabet) + '' + (i + 2)]
            const value = (position && position.v) || ''
            pkgObj[columnAlphabet] = String(value).trim()
          }
          pkgObj.trackingNumber && !rawDataMap.has(pkgObj.trackingNumber) && rawDataMap.set(pkgObj.trackingNumber, {...pkgObj})
          pkgInfoList.push({...pkgObj, ...rawData[i]})
        } 
        // 此处需要根据Excel的信息来判断，是否需要请求eevee来进行验证
        const notToCheckEevee = pkgInfoList.some(pkgInfo => pkgInfo && pkgInfo.isExists)
        let returnEeveeDataList = cloneDeep(pkgInfoList)
        if (!notToCheckEevee) {
          // 在读取文件后，直接对数据进行查询，只将符合本系统的数据放入列表中
          // 在时间进行格式转换前进行数据过滤，需要完成对eevee数据的查询
          const trackingNumbers = pkgInfoList.map(pkg => pkg && pkg.isExists === '' && pkg.trackingNumber)
          const eeveeDataList = await this.gatLabelInfoFromEevee(trackingNumbers)
          returnEeveeDataList = eeveeDataList.map(item => {
            const originData = rawDataMap.get(item.trackingNumber) || {} 
            return {...originData, ...item}
          })
        } 
        // 遍历所有数据，只需要将对应系统的数据显示在ui，并给Excel数据打上system标记
        const dataShowInSystem = []
        returnEeveeDataList.forEach((eeveeItem, index) => {
          if (eeveeItem.isExists && !eeveeItem.system && this.systemApiIdList.includes(eeveeItem.orgId)) {
            dataShowInSystem.push({...pkgInfoList[index], ...eeveeItem, status: this.returnPkgStatusList.includes(pkgInfoList[index].status) ? pkgInfoList[index].status : 'returnReceived', returnCreateTime: pkgInfoList[index].createTime || new Date()})
            eeveeItem.system = this.curSystem
            if (this.returnPackageCache.includes(eeveeItem.trackingNumber)) eeveeItem.errMsg = 'HistoryDuplicated'
          }
          delete eeveeItem.returnCreateTime
        })
        // const dataShowInSystem = returnEeveeDataList.filter(item => item.isExists && !item.system && this.systemApiIdList.includes(item.orgId)).map((eeveeItem, index) => ({...pkgInfoList[index], ...eeveeItem, system: this.curSystem, createTime: pkgInfoList[index].createTime}))
        
        // 将所有相关数据及信息导出生成新的Excel
        await this.exportExcelFromCache(returnEeveeDataList, './data.xlsx')
        // excel 读取到的时间需要转化
        const pkgInfoTransformedTimeList = dataShowInSystem.filter(item => item.isExists).map(pkg => {
          if (!this.isValidDate(pkg.returnCreateTime)) {
            pkg.returnCreateTime = this.calculateDateFromExcel(pkg.returnCreateTime)
          }
          return pkg
        })

        // 此处将列表已有的与读入的数据拼接起来
        this.newItemList = this.newItemList.concat(pkgInfoTransformedTimeList).filter(item => item && item.trackingNumber)
        this.isUploadingFile = false
      }
    },
    gatLabelInfoFromEevee (trackingNumbers) {
      return this.$store.dispatch('getLabelInfoInEeveeWithAxios', {trackingNumbers})
    },
    removeItemFromList (index) {
      if (confirm('Are you sure to delete this item?')) {
        this.newItemList.splice(index, 1)
      }
    },
    saveNewReturnItemsToDatabase (itemList) {
      return this.$store.dispatch('saveReturnPackages', itemList)
    },
    editSinglePackage (item) {
      this.isShowEditPackagePopup = true
      this.packageInEdit = cloneDeep(item)
      this.noteCache = this.packageInEdit.note || ''
      this.statusCache = this.packageInEdit.status || 'returnReceived'
    },
    deleteSinglePackage (item) {
      if (confirm(this.$t('deletePackageTip'))) {
        return this.$store.dispatch('deleteSingleReturnPackage', {id: item._key})
          .then(() => {
            this.returnPackages = this.returnPackages.filter(pkg => pkg._key !== item._key)
          })
      }
    },
    closeEditPackagePopup () {
      this.isShowEditPackagePopup = false
      this.packageInEdit = {}
    },
    lastCommentPreview (item) {
      let lastComment = item.comments[item.comments.length - 1]?.content || ''
      return lastComment.split('\n')[0] + (lastComment.split('\n')[0] ? '…' : '')
    },
    updatePackage (e, isArchivePkg = false) {
      if (this.packageInEdit.note && this.packageInEdit.note.length > this.noteLengthLimit) {
        this.$store.dispatch('showToast', {level: 'error', info: this.$t('noteLengthExceededLimit')})
        return Promise.resolve('keepPopup')
      }
      const isNeedUpdateNote = this.noteCache !== this.packageInEdit.note
      const dataNeedToUpdate = isArchivePkg ? {trackingNumber: this.packageInEdit.trackingNumber, status: 'done'} : isNeedUpdateNote ? {status: this.packageInEdit.status, trackingNumber: this.packageInEdit.trackingNumber, note: this.packageInEdit.note || ''} : {status: this.packageInEdit.status, trackingNumber: this.packageInEdit.trackingNumber}
      return this.$store.dispatch('updateReturnPackage', {...dataNeedToUpdate, originStatus: this.statusCache})
        .then(() => {
          const cloneData = cloneDeep(this.packageInEdit)
          if (isArchivePkg || cloneData.status === 'done') {
            this.isShowChatRoom = false
            this.returnPackages = this.returnPackages.filter(pkg => pkg.trackingNumber !== this.packageInEdit.trackingNumber)
          } else {
            this.isShowEditPackagePopup = false
            this.returnPackages = this.returnPackages.map(pkg => {
              if (pkg.trackingNumber === this.packageInEdit.trackingNumber) {
                return cloneData
              }
              return pkg
            })
          }
        })
        .catch(error => {
          this.$store.dispatch('showToast', {level: 'error', info: error.message})
          return Promise.resolve('keepPopup')
        })
    },
    showChatRoom (item) {
      // 本地修改lastReadTime 将已读过信息的包裹项new提示框隐藏
      this.packageInEdit = cloneDeep({...item, [`lastRead_${this.uid}`]: new Date()})
      this.isShowChatRoom = true
      this.returnPackages.map(returnItem => {
        if (returnItem.trackingNumber === item.trackingNumber) {
          return cloneDeep(this.packageInEdit)
        }
      })
    },
    getNewComment (newComment) {
      this.packageInEdit.comments.push(newComment)
      // 同时需要更新本地的lastReadTime
      this.packageInEdit[`lastRead_${this.uid}`] = new Date()
      this.returnPackages = this.returnPackages.map(pkg => {
        if (pkg.trackingNumber === this.packageInEdit.trackingNumber) {
          return cloneDeep(this.packageInEdit)
        }
        return pkg
      })
    },
    async buildRTForReturnPkgCache () {
      this.subscriber = await this.$store.dispatch('subscribeReturnPkgsCache')
    },
    getLastReadTime (item) {
      return (item && item[`lastRead_${this.$store.getters.uid}`] && item[`lastRead_${this.$store.getters.uid}`]) || new Date('2018-1-1')
    },
    checkNewMessage (item) {
      const lastReadTime = this.getLastReadTime(item)
      const newMsgTime = (item.comments && item.comments.length && item.comments[item.comments.length - 1].createTime) || new Date('2018-1-1')
      return newMsgTime > lastReadTime
    },
    calculateDateFromExcel (dateString) {
      if (dateString.includes('-')) {
        return new Date(dateString)
      }
      return new Date(new Date('1900-1-1').getTime() + (dateString - 1) * 24 * 3600000)
    },
    isValidDate (date) {
      return date instanceof Date && !isNaN(date.getTime())
    },
    downloadReturnTemplate () {
      this.$store.dispatch('downloadFile', {
        fullPath: 'templates/returnPackages-template.xlsx',
        name: 'returnPackages-template.xlsx'
      })
    },
    isShowTenantBtns (item) {
      return !['disposalInProgress', 'resendInProgress', 'resendCompleted', 'disposeCompleted', 'requestResend', 'requestDisposal'].includes(item.status)
    },
    downLoadLabel (item) {
      const {readyLabels = []} = item
      const fullPath = readyLabels[0].fullPath
      const name = readyLabels[0].name
      this.$store.dispatch('downloadFile', {fullPath, name})
    },
    showResendPopup (item) {
      this.packageInEdit = cloneDeep(item)
      this.uploadedFile = cloneDeep(this.packageInEdit.readyLabels) || []
      this.isShowResendPopup = true
    },
    requestForDisposal (item) {
      if (prompt(this.$t('returnPackagesDisposalWarning')) === item.trackingNumber) {
        const requestContent = `${item.clientName} request disposal`
        const comments = [{content: requestContent, createTime: new Date(), name: item.clientName, userKey: this.uid}]
        return this.$store.dispatch('updateReturnPackage', {trackingNumber: item.trackingNumber, status: 'requestDisposal', comments, originStatus: item.status || 'returnReceived'})
          .then(() => {
            item.comments.push(...comments)
            const cloneData = cloneDeep({...item, status: 'requestDisposal', [`lastRead_${this.uid}`]: new Date()})
            this.isShowEditPackagePopup = false
            this.returnPackages = this.returnPackages.map(pkg => {
              if (pkg.trackingNumber === item.trackingNumber) {
                return cloneData
              }
              return pkg
            })
          })
      }
    },
    requestForResend (item) {
      const requestContent = `${this.packageInEdit.clientName} request resend`
      const comments = [{content: requestContent, createTime: new Date(), name: this.packageInEdit.clientName, userKey: this.uid}]
      return this.$store.dispatch('updateReturnPackage', {readyLabels: [...this.uploadedFile], trackingNumber: this.packageInEdit.trackingNumber, status: 'requestResend', comments, originStatus: item.status || 'returnReceived'})
        .then(() => {
          this.packageInEdit.comments.push(...comments)
          const cloneData = cloneDeep({...this.packageInEdit, status: 'requestResend', [`lastRead_${this.uid}`]: new Date()})
          this.isShowEditPackagePopup = false
          this.returnPackages = this.returnPackages.map(pkg => {
            if (pkg.trackingNumber === this.packageInEdit.trackingNumber) {
              return cloneData
            }
            return pkg
          })
        })
    },
    async exportExcelFromCache (rawData, outputFilepath) {
      try {
        await this.writeFile('data.xlsx', rawData, outputFilepath)
      } catch (error) {
        console.log('error', error)
      }
    },
    async writeFile (workSheetName, rawData, outputFilepath) {
      const workbook = xlsx.utils.book_new()
      const sheet = xlsx.utils.json_to_sheet(rawData)
      xlsx.utils.book_append_sheet(workbook, sheet, workSheetName)
      return xlsx.writeFile(workbook, outputFilepath)
    }
  },
  watch: {
    newItemList (newValue, oldValue) {
      if (this.isAvailableToSubmit) this.isAfterCheck = false
    }
  },
  beforeDestroy () {
    this.subscriber && this.subscriber()
  }
}
</script>

<style scoped>
.chatRoom .v-badge{
  width: 5px;
  height: 5px;
  top: -10px;
  right: 13px;
}
.hideInput {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  min-height: 100%;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}
.returnPackageFloatText {
  position: absolute;
  top: -35px;
  right: -190px;
  width: 100%;
  flex-wrap: nowrap;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/ReturnPackages.vue